/* eslint-disable @typescript-eslint/camelcase */
import { FcsFlag } from "../unleash";

export const FlagsHelpCenter = {
  permission_help_center: new FcsFlag.Flag(false)
};

const FcsPermissionHelpCenterPayload = {
  config_help_center_embed: new FcsFlag.JSONFlag({})
};

export function initFlagsHelpCenter(): void {
  FcsFlag.register("featureHelpCenter", FlagsHelpCenter);
  FcsFlag.register("featureHelpCenter", FcsPermissionHelpCenterPayload);
}

export interface HelpCenterEmbedAction {
  icon: string;
  label: string;
  path: string;
}

export interface HelpCenterEmbedConfig {
  tabs: string[];
  trademark: boolean;
  actions: HelpCenterEmbedAction[];
}

const VALID_TABS = ["assistant", "search", "docs"];

export const DEFAULT_HELP_CENTER_EMBED_CONFIG: HelpCenterEmbedConfig = {
  tabs: ["assistant"],
  trademark: false,
  actions: [
    {
      icon: "book-open",
      label: "Dokumentasi",
      path: "/documentation"
    },
    {
      icon: "newspaper",
      label: "Agent News",
      path: "/news/berita/pusat-informasi-berita"
    },
    {
      icon: "bullhorn",
      label: "Sosialisasi",
      path: "/news/socialization/operasional-pengiriman"
    }
  ]
};

function isValidTab(value: unknown): value is string {
  return typeof value === "string" && VALID_TABS.includes(value);
}

function isValidAction(value: unknown): value is HelpCenterEmbedAction {
  if (typeof value !== "object" || value === null) return false;
  const item = value as Record<string, unknown>;
  const labelOk =
    typeof item.label === "string" && item.label.trim().length > 0;
  const pathOk =
    typeof item.path === "string" &&
    item.path.length > 0 &&
    item.path.startsWith("/");
  const iconOk =
    item.icon === undefined ||
    (typeof item.icon === "string" && item.icon.length > 0);
  return labelOk && pathOk && iconOk;
}

export function getHelpCenterEmbedConfig(): HelpCenterEmbedConfig {
  const payload =
    FcsPermissionHelpCenterPayload.config_help_center_embed.getValue();

  if (!payload || typeof payload !== "object") {
    return DEFAULT_HELP_CENTER_EMBED_CONFIG;
  }

  const tabs = Array.isArray(payload.tabs)
    ? payload.tabs.filter(isValidTab)
    : [];
  const actions = Array.isArray(payload.actions)
    ? payload.actions.filter(isValidAction).map(action => ({
        icon: typeof action.icon === "string" ? action.icon : "",
        label: action.label,
        path: action.path
      }))
    : [];

  return {
    tabs: tabs.length > 0 ? tabs : DEFAULT_HELP_CENTER_EMBED_CONFIG.tabs,
    trademark:
      typeof payload.trademark === "boolean"
        ? payload.trademark
        : DEFAULT_HELP_CENTER_EMBED_CONFIG.trademark,
    actions:
      actions.length > 0 ? actions : DEFAULT_HELP_CENTER_EMBED_CONFIG.actions
  };
}
